const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Analyze managers Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AnalyzeManager', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
    return $resource(appConfiguration.analyzeUrl + '/api/v1/manager/:subresource/:itemid/:third/:fourth', null, {
      user: {params: {subresource: 'user', itemid: '', third: 'from', fourth: ''}, method: 'GET', isArray: false},
      content: {params: {subresource: 'content', itemid: ''}, method: 'GET', isArray: false}
    });
  }]);